import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';
import { IUser } from '../users/UserServices';

export interface ICompany {
    nome: string;
    company_name: string;
    company_register: string;
    quantidade_barragens: number;
    numero: string;
    pais: string;
    bairro: string;
    cep: string;
    cidade: string;
    rua: string;

    complemento?: string;
    email?: string;
    estado: string;
    logo?: string;
    phone?: string;
    site?: string;
    slug?: string;
    status?: boolean;
    uuid?: string;
    image?: string | File; 
    image_logo?: string;
    responsavel?: IUser;
}

export interface IListCompany {
    uuid: string;
    nome: string;
    status: boolean;
    image?: string;
}

const get = async (): Promise<IListCompany[] | Error> => {

    await AuthService.verify();

    console.log(AuthService.verify());


    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get('./empresas', {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `${token}`
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao listar registros.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro na requisição de listagem.');
    }
};

const getById = async(uuid: string): Promise<ICompany | Error> => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get('./empresa', {
            params: {
                'uuid': uuid
            },
            headers: {
                Authorization: `${token}`
            }
        });

        if(response.data) {
            return response.data;
        }

        return new Error('Erro ao buscar registro');
    } catch (error) {
        return new Error((error as { message: string }).message || 'Erro ao buscar registro');
    }
};

const create = async (data: ICompany): Promise<ICompany | Error> => {
    try {
        await AuthService.verify();
    
        const token = await AuthService.getAccessToken();
    
        const response = await ApiBack.post('/empresa', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `${token}` 
            }
        });
    
        if (response.data) {
            return response.data;
        }
    
        return new Error('Erro ao criar nova empresa');
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar empresa');
        }
    }
};


const delet = async(uuid: string): Promise<any | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.delete('./empresa', {
            headers: {
                Authorization: `${token}`
            },
            params: {
                'uuid': uuid
            }
        });

        if(response.data){
            return response.data; 
        }

        return new Error('Falha ao deletar empresa');
    } catch (error) {
        Error((error as { message: string}).message || 'Erro ao deletar empresa');
    }
};


const upgrade = async(uuid: string, data: ICompany): Promise<any | Error> => {

    await AuthService.verify();

    try{
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.put(`./empresa?uuid=${uuid}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `${token}`
            }
        });

        if(response.data){
            return response.data;
        }
        
        return new Error('Falha ao atualizar empresa');
    } catch (error) {
        return new Error((error as { menssage: string}).menssage || 'Error ao atualizar empresa');
    }
};

export const CompanyServices = {
    get,
    getById,
    create,
    delet,
    upgrade
};